module.exports = __webpack_public_path__ + "media/PAG90-06.a15f796f.mp3";